// Tipos para el sistema multijugador

export interface CrearSalaMultijugadorDTO {
  nombreSala: string;
  maxParticipantes?: number;
  tiempoLimiteMin?: number;
  permitirEntradaTardia?: boolean;
  cantidadReactivos: number;
  especialidadIds: number[];
  dificultadId: number;
}

export interface UnirseSalaDTO {
  codigoSala: string;
}

export interface ParticipanteSalaDTO {
  id: number;
  usuarioId: number;
  nombreUsuario: string;
  avatarUrl?: string;
  unidoEn: string;
  estado: EstadoParticipante;
  intentoExamenId?: number;
  puntuacion?: number;
  posicionFinal?: number;
  tiempoTotalSegundos?: number;
  preguntasCorrectas?: number;
  preguntasIncorrectas?: number;
  preguntasEnBlanco?: number;
  finalizoExamen: boolean;
  esCreador: boolean;
}

export interface SalaMultijugadorResponseDTO {
  id: number;
  codigoSala: string;
  nombreSala: string;
  creadorId: number;
  nombreCreador: string;
  estado: EstadoSala;
  maxParticipantes: number;
  cantidadParticipantes: number;
  creadaEn: string;
  iniciadaEn?: string;
  finalizadaEn?: string;
  tiempoLimiteMin: number;
  permitirEntradaTardia: boolean;
  participantes: ParticipanteSalaDTO[];
  examenId: number;
  nombreExamen: string;
  totalPreguntas: number;
  esCreador: boolean;
}

export interface RankingSalaDTO {
  codigoSala: string;
  nombreSala: string;
  salaFinalizada: boolean;
  ranking: ParticipanteSalaDTO[];
  totalParticipantes: number;
  participantesTerminados: number;
}

export enum EstadoSala {
  ESPERANDO = 'ESPERANDO',
  EN_PROGRESO = 'EN_PROGRESO',
  FINALIZADA = 'FINALIZADA',
  CANCELADA = 'CANCELADA'
}

export enum EstadoParticipante {
  ESPERANDO = 'ESPERANDO',
  LISTO = 'LISTO',
  EN_EXAMEN = 'EN_EXAMEN',
  TERMINADO = 'TERMINADO',
  DESCONECTADO = 'DESCONECTADO'
}

// Tipos para WebSocket
export interface WebSocketMessage {
  tipo: string;
  codigoSala?: string;
  timestamp?: number;
  datos?: any;
}

export interface WebSocketConnection {
  connected: boolean;
  connecting: boolean;
  error?: string;
}

// Tipos para navegación
export interface MultijugadorNavigationState {
  sala?: SalaMultijugadorResponseDTO;
  intentoId?: number;
  fromMultiplayer?: boolean;
}